module.exports = __webpack_public_path__ + "assets/img/26_745_big.6735a546.jpg";